import { render, staticRenderFns } from "./VTwoPost.vue?vue&type=template&id=0e43ed01"
import script from "./VTwoPost.vue?vue&type=script&lang=js"
export * from "./VTwoPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports